import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import {
  chargeSubscriptionNow,
  fetchSubscriptions,
  updateSubscriptionStatus,
} from 'modules/arena/subscriptions/subscriptionsService';
import { StudentSubscription } from 'modules/arena/subscriptions/types';

export function useArenaSubscriptions() {
  const { data: subscriptions, isLoading, error, setData: setSubscriptions } = useAsyncData<StudentSubscription[]>(
    fetchSubscriptions,
    []
  );
  const [filter, setFilter] = useState('all');
  const [selectedId, setSelectedId] = useState<string>('');

  const filteredSubscriptions =
    filter === 'all' ? subscriptions : subscriptions.filter((subscription) => subscription.status === filter);

  const selectedSubscription =
    subscriptions.find((subscription) => subscription.id === selectedId) ?? subscriptions[0] ?? null;

  function updateSubscription(id: string, patch: Partial<StudentSubscription>) {
    setSubscriptions((prev) =>
      prev.map((subscription) => (subscription.id === id ? { ...subscription, ...patch } : subscription))
    );
  }

  function chargeNow(id: string) {
    const subscription = subscriptions.find((item) => item.id === id);
    if (!subscription) return;

    updateSubscription(id, {
      status: 'ativa',
      paymentHistory: subscription.paymentHistory.map((payment, index) =>
        index === subscription.paymentHistory.length - 1 ? { ...payment, status: 'pago' } : payment
      ),
    });
    chargeSubscriptionNow(id).catch(() => {});
  }

  function cancelSubscription(id: string) {
    updateSubscription(id, { status: 'cancelada' });
    updateSubscriptionStatus(id, 'cancelada').catch(() => {});
  }

  function reactivateSubscription(id: string) {
    updateSubscription(id, { status: 'ativa' });
    updateSubscriptionStatus(id, 'ativa').catch(() => {});
  }

  return {
    subscriptions,
    isLoading,
    error,
    filteredSubscriptions,
    filter,
    setFilter,
    selectedId,
    setSelectedId,
    selectedSubscription,
    chargeNow,
    cancelSubscription,
    reactivateSubscription,
  };
}
